<template>
  <div class="asc-report-list-template">
    <v-row no-gutters>
      <v-col cols="12" sm="12">
        <asc-report-grid-export-header
          :title="title"
          :on-export-options="onExportOptions"
          :on-apu-cycle-export="onApuCycleExport"
          :on-fault-monitor-export="onFaultMonitorExport"
          :on-fleet-alerts-export="onFleetAlertsExport"
          :on-fleet-messages-export="onFleetMessagesExport"
          :export-button-visible="isexportButtonVisible"
          :export-button-disabled="exportButtonDisabled"
        />
      </v-col>
    </v-row>
    <v-row no-gutters>
      <v-col cols="12" sm="12">
        <asc-event-report-grid-wrapper
          v-if="isEventReportActive"
          title="ACMF Event Reports"
          :values="eventValues"
          :grid-filters="gridFilters"
          :event-report-filter-fields="eventReportFilterFields"
          :on-open="onEventReportOpen"
          :on-open-report-summary="onOpenEventReportSummary"
          :is-grid-data-loaded="eventGridDataLoaded"
          :loading="eventReportLoading"
          :grid-columns="gridColumns"
          @onFiltersChange="handleEventFiltersChange"
        />
        <asc-report-grid-wrapper
          title="ALL ACMF REPORTS"
          :values="values"
          :on-open="onOpen"
          :on-open-report-summary="onOpenReportSummary"
          :export-button-visible="exportButtonVisible"
          :grid-filters="gridFilters"
          :on-filters-change="onFiltersChange"
          :on-filters-submit="onFiltersSubmit"
          :on-filters-disable-submit="onFiltersDisableSubmit"
          :report-filter-fields="reportFilterFields"
          :filter-lookups="filterLookups"
          :is-grid-data-loaded="isGridDataLoaded"
        />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import {
  AscGridExportPropsMixin,
  AscGridPropsMixin,
  AscRangeDatePickerMixin,
} from '@/components/mixins'
import AscReportGridExportHeader from '@/components/molecules/AscReportGridExportHeader'
import {
  AscEventReportGridWrapper,
  AscReportGridWrapper,
} from '@/components/organisms'
import AppFeatureFlags from '@/utilities/appFeatureFlags'

export default {
  name: 'AscReportListTemplate',

  components: {
    AscReportGridExportHeader,
    AscReportGridWrapper,
    AscEventReportGridWrapper,
  },

  mixins: [AscGridPropsMixin, AscGridExportPropsMixin, AscRangeDatePickerMixin],

  props: {
    onFiltersChange: {
      type: Function,
      default: () => {},
    },
    onFiltersSubmit: {
      type: Function,
      default: () => {},
    },
    onFiltersDisableSubmit: {
      type: Function,
      default: () => {},
    },
    reportFilterFields: {
      type: Array,
      default: () => [],
    },
    filterLookups: {
      type: Array,
      default: () => [],
    },
    onApuCycleExport: {
      type: Function,
      default: () => {},
    },
    onFaultMonitorExport: {
      type: Function,
      default: () => {},
    },
    onFleetAlertsExport: {
      type: Function,
      default: () => {},
    },
    onFleetMessagesExport: {
      type: Function,
      default: () => {},
    },
    onOpenReportSummary: {
      type: Function,
      default: () => {},
    },
    eventValues: {
      type: Array,
      default: () => [],
    },
    eventReportFilterFields: {
      type: Array,
      default: () => [],
    },
    eventReportLoading: {
      type: Boolean,
      default: false,
    },
    onEventReportOpen: {
      type: Function,
      default: () => {},
    },
    eventGridDataLoaded: {
      type: Boolean,
      default: false,
    },
    onOpenEventReportSummary: {
      type: Function,
      default: () => {},
    },
    exportButtonDisabled: {
      type: Boolean,
      default: false,
    },
    gridColumns: {
      type: Array,
      default: () => [],
    },
  },

  computed: {
    isexportButtonVisible() {
      return this.exportButtonVisible && AppFeatureFlags.getReportListExport()
    },
    isEventReportActive() {
      return AppFeatureFlags.getEventReports()
    },
  },

  methods: {
    handleEventFiltersChange(payload) {
      this.$emit('onEventFiltersChange', payload)
    },
  },
}
</script>
